<template>
  <v-container fluid class="fill-height" id="teacherpurchaseconfirmation">
    <v-row align="center" justify="center">
      <v-col cols="12" class="text-center" style="justify-items: center">
        <h1>Thank You!</h1>

        <div v-if="userSignedIn">
          <p>We appreciate your purchase. Your order is being processed.</p>
          <p v-if="!receipt">
            You will be redirected to your purchased resources in a short moment
          </p>
        </div>

        <div v-else>
          <p class="primary--text">
            Please check your email for all the relevant order and download
            information.
          </p>
        </div>

        <div
          v-if="receipt"
          class="d-flex flex-column align-center my-4"
          style="gap: 12px"
        >
          <v-btn v-if="downloadPath" color="primary" large :to="downloadPath">
            <v-icon left>mdi-download</v-icon>
            Download your resources
          </v-btn>
          <span v-else-if="checkingDownload" class="text-body-2">
            Confirming your payment...
          </span>
          <v-btn
            text
            color="primary"
            :to="userSignedIn ? '/app/bought-products' : '/'"
          >
            {{ userSignedIn ? "Go to my resources" : "Continue shopping" }}
          </v-btn>
        </div>

        <div
          class="d-flex flex-column align-center"
          style="gap: 24px; height: min-content; width: min-content"
        >
          <v-img
            :height="$vuetify.breakpoint.smAndDown ? '150' : '100%'"
            :class="$vuetify.breakpoint.smAndDown ? 'mb-0' : 'mb-7'"
            :width="$vuetify.breakpoint.smAndDown ? '93' : 'auto'"
            src="@/assets/juffrou-anri-animate.gif"
            contain
            class="mb-0"
          ></v-img>
          <v-progress-linear
            v-if="!receipt || checkingDownload"
            indeterminate
            height="2"
            color="primary"
          ></v-progress-linear>
          <!-- <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular> -->
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
// import Helper from "@/components/global-components/Helper.vue";
import { DataStore, API } from "aws-amplify";
import { ProductCategory } from "@/models";
import { updateTeacherProfile } from "@/graphql/mutations";
import { getProductCategory } from "@/graphql/queries";
import store from "@/store";
import { buildTrackingDataLayerFields, clearAdMeta } from "@/core/utils/adMeta";
import { getOrderReceipt } from "@/core/utils/orderReceipt";

export default {
  name: "TeacherPurchaseConfirmation",
  // components: { Helper },
  data: () => ({
    initiallyLoaded: false,
    receipt: null,
    downloadPath: "",
    checkingDownload: false,
    downloadPollTimer: null,
  }),

  computed: {
    ...mapState({
      offline: (state) => !state.isOnline,
      userSignedIn: (state) => state.userSignedIn,
      syncedTeacherProductsOrders: (state) => state.syncedTeacherProductsOrders,
      syncedTeacherProductsOrderModels: (state) =>
        state.syncedTeacherProductsOrderModels,
      syncedTeacherProfileModel: (state) => state.syncedTeacherProfileModel,
    }),
  },

  async mounted() {
    try {
      this.receipt = getOrderReceipt(this.$route.params.orderId);
      if (this.receipt) this.checkDownloadAccess();

      // Clear guest cart so it doesn't reappears
      store.commit("clearGuestCart");

      if (!this.userSignedIn) {
        this.fetchOrder();
        // this.scheduleRedirect("/");
      }
    } catch (error) {
      console.log(error);
    }
  },

  watch: {
    syncedTeacherProductsOrders: {
      handler(val) {
        console.log("syncedTeacherProductsOrders changed:", val);
        console.log("this.$route.params.orderId:", this.$route.params.orderId);
        if (val === true && typeof this.$route.params.orderId === "string") {
          // console.log("this.$route.params:", this.$route.params);
          const order = _.find(this.syncedTeacherProductsOrderModels, {
            orderID: this.$route.params.orderId,
          });
          console.log("Found order:", order);
          if (order && !this.initiallyLoaded) {
            this.saveConversion(order);
          }
        }
      },
      immediate: true,
    },
  },

  methods: {
    async checkDownloadAccess(attempt = 0) {
      if (!this.receipt) return;
      this.checkingDownload = true;

      try {
        const res = await API.post(
          "guestcartapi",
          "/item/confirm-order-receipt",
          {
            body: {
              orderRecordId: this.receipt.orderRecordId,
              orderID: this.$route.params.orderId,
              thankyouToken: this.receipt.token,
            },
          },
        );

        if (res?.status === "PAID" && res.downloadPath) {
          this.downloadPath = res.downloadPath;
          this.checkingDownload = false;
          return;
        }

        // Payfast ITN can land a few seconds after the redirect - poll ~60s
        if (res?.success && res.status === "PENDING" && attempt < 20) {
          this.downloadPollTimer = setTimeout(
            () => this.checkDownloadAccess(attempt + 1),
            3000,
          );
          return;
        }
      } catch (error) {
        console.log("checkDownloadAccess error:", error);
      }

      this.checkingDownload = false;
    },

    // Don't navigate away from the download button for the actual buyer
    scheduleRedirect(path) {
      if (this.receipt) return;
      setTimeout(() => {
        this.$router.push({ path });
      }, 7000);
    },

    async fetchOrder() {
      try {
        const response = await API.get(
          "payfastsubscriptionapi",
          `/confirmOrderPaid/${this.$route.params.orderId}`,
        );
        const order = response.order;
        console.log("Fetched order:", order);
        if (order.orderStatus === "PAID") {
          this.saveConversion(order);
        } else {
        this.scheduleRedirect("/");
        }
      } catch (error) {
        console.error("Error confirming order:", error);
        this.scheduleRedirect("/");
      }
    },

    async saveConversion(order) {
      try {
        this.initiallyLoaded = true;
        
        console.log("order:", order);

        if (order.orderStatus === "PAID") {
          // if (window.fbq) {
          //   console.log("Tracking Facebook Purchase event for order:", {
          //     value: order.orderTotal,
          //     currency: "ZAR",
          //     content_ids: order.orderProducts.map((product) => product.id),
          //     content_type: "product",
          //   });
          //   // eslint-disable-next-line no-undef
          //   fbq("track", "Purchase", {
          //     value: order.orderTotal,
          //     currency: "ZAR",
          //     content_ids: order.orderProducts.map((product) => product.id),
          //     content_type: "product",
          //   });
          // }

          window.dataLayer = window.dataLayer || [];
          // window.dataLayer.push({
          //   event: 'purchase',
          //   orderID: order.orderID,
          //   orderTotal: order.orderTotal,
          //   currency: 'ZAR',
          // });

          const orderTotal = this.calculateOrderTotal(order);
          // console.log("Calculated orderTotal:", orderTotal);

          const orderVAT = this.calculateOrderVAT(orderTotal);
          // console.log("Calculated orderVAT:", orderVAT);

          const dataLayerObj = {
            event: "purchase",
            transaction_id: order.orderID, // GA4 prefers 'transaction_id'
            value: orderTotal, // GA4 prefers 'value' for total revenue
            currency: "ZAR",
            tax: orderVAT, // Optional: include VAT if desired
            ...buildTrackingDataLayerFields(order.meta),
            items: order.orderProducts.map((product) => { 
let price = product.price && product.discountPercentage
          ? product.price - product.price * (product.discountPercentage / 100)
          : product.price;

          if (!product.physical && order.coupon) {
            const parsedCoupon = typeof order.coupon === "string" ? JSON.parse(order.coupon) : order.coupon;

      if (parsedCoupon) {
        const percentageType = parsedCoupon.discount.type === "PERCENTAGE";

        price = percentageType
          ? price - price * (parsedCoupon.discount.value / 100)
          : price - parsedCoupon.discount.value;
      }
          }
              
              return {
              item_id: product.id, // Use 'sku' as a unique identifier
              item_name: product.title, // Product name
              price: price, // Unit price of the item
              quantity: 1, // Assume 1 unless quantity exists
              item_category: product.categoryId, // Category identifier
            }
          }),
          }

          console.log("Pushing to dataLayer:", dataLayerObj);

          window.dataLayer.push(dataLayerObj);
          clearAdMeta(); // attribution consumed – reset for the next journey
          
            if (this.userSignedIn) {
          try {
            const profile = this.syncedTeacherProfileModel;
            if (profile) {
              let smart = profile.smartProductSort
                ? _.cloneDeep(profile.smartProductSort)
                : { grades: [], categories: [] };
              if (!smart.grades) smart.grades = [];
              if (!smart.categories) smart.categories = [];
              for (const product of order.orderProducts) {
                console.log('product:', product);
                if (!smart.categories.includes(product.categoryId)) {
                  smart.categories.push(product.categoryId);
                }
                // const category = await DataStore.query(
                //   ProductCategory,
                //   product.categoryId,
                // );
                const categoryResponse = await API.graphql({
                query: getProductCategory,
                variables: {
                    id: product.categoryId
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
              });

               const category = categoryResponse.data.getProductCategory;
                if (
                  category &&
                  category.grade &&
                  !smart.grades.includes(category.grade)
                ) {
                  smart.grades.push(category.grade);
                }
              }

              smart.grades = [...new Set(smart.grades)];
              smart.categories = [...new Set(smart.categories)];

              await API.graphql({
                query: updateTeacherProfile,
                variables: {
                  input: {
                    id: profile.id,
                    _version: profile._version,
                    smartProductSort: JSON.stringify(smart),
                  },
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
              });

              // await DataStore.save(
              //   TeacherProfile.copyOf(profile, (updated) => {
              //     updated.smartProductSort = smart;
              //   }),
              // );
            }
          } catch (error) {
            console.log("Error updating smartProductSort from order:", error);
          }

        this.scheduleRedirect("/app/bought-products");

          } else {
        this.scheduleRedirect("/");
          }
        }

      } catch (error) {
        console.log(error);

if (!this.userSignedIn) {
        this.scheduleRedirect("/");
      } else {
        this.scheduleRedirect("/app/bought-products");
      }
        
      }
    },

    calculateOrderTotal(item) {
      if (!item || !item.orderProducts) return 0;
      let orderTotal = 0;

      //calculate NonPhysicalProductsPrice
      const nonPhysicalProducts = item.orderProducts.filter(
        (product) => !product.physical || product.physical === false,
      );
      const nonPhysicalProductsPrice = nonPhysicalProducts.reduce(
        (total, product) => {
          const price = product.price || 0;
          const discount = product.discountPercentage || 0;
          return total + price * (1 - discount / 100);
        },
        0,
      );

      //calculate PhysicalProductsPrice
      const physicalProducts = item.orderProducts.filter(
        (product) => product.physical === true,
      );
      const physicalProductsPrice = physicalProducts.reduce(
        (total, product) => {
          const price = product.price || 0;
          const discount = product.discountPercentage || 0;
          return total + price * (1 - discount / 100);
        },
        0,
      );

      //calculate AddonsTotal

      // Previous code - did not account for addons being null or undefined, or not being an array
      //const addonsTotal = item.orderProducts.reduce((total, product) => {
      //   return (
      //     total +
      //     (product.addons
      //       ? product.addons.reduce((sum, addon) => sum + (addon.price || 0), 0)
      //       : 0)
      //   );
      // }, 0);

      const addonsTotal = item.orderProducts.reduce((total, product) => {
        const addons = Array.isArray(product.addons) ? product.addons : [];
        return (
          total + addons.reduce((sum, addon) => sum + (addon?.price || 0), 0)
        );
      }, 0);

      orderTotal =
        nonPhysicalProductsPrice +
        physicalProductsPrice +
        addonsTotal +
        (item.orderProducts.some((product) => product.physical === true)
          ? 130.0
          : 0);

      //calculate coupon discount if applicable
      let discount = 0;
      if (item.coupon) {
        if (item.coupon.discount.type === "PERCENTAGE") {
          discount = orderTotal * (item.coupon.discount.value / 100);
        } else {
          discount = item.coupon.discount.value;
        }
      }
      orderTotal = orderTotal - discount;

      // console.log(
      //   `${
      //     item.orderID
      //   }: ${orderTotal} = ${nonPhysicalProductsPrice} (non-physical) + ${physicalProductsPrice} (physical) + ${addonsTotal} (addons) + ${
      //     item.orderProducts.some((product) => product.physical === true)
      //       ? 130.0
      //       : 0
      //   } (shipping) - ${discount} (coupon discount)`
      // );

      return parseFloat(orderTotal.toFixed(2));
    },

    calculateOrderVAT(orderTotal) {
     return orderTotal
        ? Number.parseFloat(
            ((orderTotal / (1 + 0.15) - orderTotal) *
              -1).toFixed(2)
          )
        : 0;
    },
  },

  beforeDestroy() {
    if (this.downloadPollTimer) clearTimeout(this.downloadPollTimer);
  },
};
</script>
